import React from "react";

export default function WheelPreview({ colors = [
    "#FF5733", "#4bd6d6", "#3357FF", "#FF33A8", "#A833FF",
    "#07504c", "#F5FF33", "#FF8C33", "#8C33FF", "#33FF8C",
    "#FF3333", "#dc6161", "#3333FF", "#d05dd0", "#6868ad",
    "#FFFF33", "#FF6633", "#6633FF", "#393c3a", "#66FF33"
  ] }) {
  return (
    <svg
      width="254"
      height="253"
      viewBox="0 0 254 253"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_729_30204"
        maskUnits="userSpaceOnUse"
        x="125.415"
        y="0.804682"
        width="43"
        height="106"
        fill="black"
      >
        <rect fill="white" x="125.415" y="0.804682" width="43" height="106" />
        <path d="M127 1.80468C140.425 1.80468 153.763 3.95302 166.504 8.16767L134.111 105.45C131.817 104.691 129.417 104.305 127 104.305L127 1.80468Z" />
      </mask>
      <path
        d="M127 1.80468C140.425 1.80468 153.763 3.95302 166.504 8.16767L134.111 105.45C131.817 104.691 129.417 104.305 127 104.305L127 1.80468Z"
        fill={colors[0]?.hex}
      />
      <path
        d="M127 1.80468C140.425 1.80468 153.763 3.95302 166.504 8.16767L134.111 105.45C131.817 104.691 129.417 104.305 127 104.305L127 1.80468Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-1-outside-1_729_30204)"
      />
      <mask
        id="path-2-outside-2_729_30204"
        maskUnits="userSpaceOnUse"
        x="132.415"
        y="5.80468"
        width="71"
        height="105"
        fill="black"
      >
        <rect fill="white" x="132.415" y="5.80468" width="71" height="105" />
        <path d="M165.615 7.87718C178.388 11.9969 190.414 18.134 201.234 26.0539L140.362 108.67C138.415 107.244 136.25 106.139 133.951 105.398L165.615 7.87718Z" />
      </mask>
      <path
        d="M165.615 7.87718C178.388 11.9969 190.414 18.134 201.234 26.0539L140.362 108.67C138.415 107.244 136.25 106.139 133.951 105.398L165.615 7.87718Z"
        fill={colors[1]?.hex}
      />
      <path
        d="M165.615 7.87718C178.388 11.9969 190.414 18.134 201.234 26.0539L140.362 108.67C138.415 107.244 136.25 106.139 133.951 105.398L165.615 7.87718Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-2-outside-2_729_30204)"
      />
      <mask
        id="path-3-outside-3_729_30204"
        maskUnits="userSpaceOnUse"
        x="143.415"
        y="51.8047"
        width="105"
        height="70"
        fill="black"
      >
        <rect fill="white" x="143.415" y="51.8047" width="105" height="70" />
        <path d="M228.847 53.8614C236.681 64.7274 242.714 76.7765 246.715 89.5488L148.549 120.099C147.829 117.8 146.743 115.631 145.333 113.675L228.847 53.8614Z" />
      </mask>
      <path
        d="M228.847 53.8614C236.681 64.7274 242.714 76.7765 246.715 89.5488L148.549 120.099C147.829 117.8 146.743 115.631 145.333 113.675L228.847 53.8614Z"
        fill={colors[3]?.hex}
      />
      <path
        d="M228.847 53.8614C236.681 64.7274 242.714 76.7765 246.715 89.5488L148.549 120.099C147.829 117.8 146.743 115.631 145.333 113.675L228.847 53.8614Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-3-outside-3_729_30204)"
      />
      <mask
        id="path-4-outside-4_729_30204"
        maskUnits="userSpaceOnUse"
        x="146.415"
        y="87.8047"
        width="107"
        height="43"
        fill="black"
      >
        <rect fill="white" x="146.415" y="87.8047" width="107" height="43" />
        <path d="M246.658 89.3652C250.679 102.131 252.617 115.458 252.399 128.837L149.572 127.17C149.611 124.762 149.262 122.363 148.538 120.066L246.658 89.3652Z" />
      </mask>
      <path
        d="M246.658 89.3652C250.679 102.131 252.617 115.458 252.399 128.837L149.572 127.17C149.611 124.762 149.262 122.363 148.538 120.066L246.658 89.3652Z"
        fill={colors[4]?.hex}
      />
      <path
        d="M246.658 89.3652C250.679 102.131 252.617 115.458 252.399 128.837L149.572 127.17C149.611 124.762 149.262 122.363 148.538 120.066L246.658 89.3652Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-4-outside-4_729_30204)"
      />
      <mask
        id="path-5-outside-5_729_30204"
        maskUnits="userSpaceOnUse"
        x="138.415"
        y="23.8047"
        width="92"
        height="92"
        fill="black"
      >
        <rect fill="white" x="138.415" y="23.8047" width="92" height="92" />
        <path d="M200.268 25.3538C211.164 33.1706 220.73 42.6804 228.6 53.52L145.288 113.613C143.871 111.662 142.15 109.951 140.188 108.543L200.268 25.3538Z" />
      </mask>
      <path
        d="M200.268 25.3538C211.164 33.1706 220.73 42.6804 228.6 53.52L145.288 113.613C143.871 111.662 142.15 109.951 140.188 108.543L200.268 25.3538Z"
        fill={colors[2]?.hex}
      />
      <path
        d="M200.268 25.3538C211.164 33.1706 220.73 42.6804 228.6 53.52L145.288 113.613C143.871 111.662 142.15 109.951 140.188 108.543L200.268 25.3538Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-5-outside-5_729_30204)"
      />
      <mask
        id="path-6-outside-6_729_30204"
        maskUnits="userSpaceOnUse"
        x="146.415"
        y="125.805"
        width="107"
        height="42"
        fill="black"
      >
        <rect fill="white" x="146.415" y="125.805" width="107" height="42" />
        <path d="M252.415 126.805C252.415 140.185 250.26 153.479 246.031 166.178L148.426 133.892C149.187 131.606 149.575 129.213 149.575 126.805L252.415 126.805Z" />
      </mask>
      <path
        d="M252.415 126.805C252.415 140.185 250.26 153.479 246.031 166.178L148.426 133.892C149.187 131.606 149.575 129.213 149.575 126.805L252.415 126.805Z"
        fill={colors[5]?.hex}
      />
      <path
        d="M252.415 126.805C252.415 140.185 250.26 153.479 246.031 166.178L148.426 133.892C149.187 131.606 149.575 129.213 149.575 126.805L252.415 126.805Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-6-outside-6_729_30204)"
      />
      <mask
        id="path-7-outside-7_729_30204"
        maskUnits="userSpaceOnUse"
        x="85.5848"
        y="146.805"
        width="43"
        height="106"
        fill="black"
      >
        <rect fill="white" x="85.5848" y="146.805" width="43" height="106" />
        <path d="M127 251.805C113.575 251.805 100.237 249.656 87.4959 245.442L119.889 148.159C122.183 148.918 124.584 149.305 127 149.305L127 251.805Z" />
      </mask>
      <path
        d="M127 251.805C113.575 251.805 100.237 249.656 87.4959 245.442L119.889 148.159C122.183 148.918 124.584 149.305 127 149.305L127 251.805Z"
        fill={colors[10]?.hex}
      />
      <path
        d="M127 251.805C113.575 251.805 100.237 249.656 87.4959 245.442L119.889 148.159C122.183 148.918 124.584 149.305 127 149.305L127 251.805Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-7-outside-7_729_30204)"
      />
      <mask
        id="path-8-outside-8_729_30204"
        maskUnits="userSpaceOnUse"
        x="0.584756"
        y="85.8047"
        width="107"
        height="42"
        fill="black"
      >
        <rect fill="white" x="0.584756" y="85.8047" width="107" height="42" />
        <path d="M1.58476 126.805C1.58476 113.424 3.74023 100.131 7.96888 87.4313L105.574 119.717C104.813 122.003 104.425 124.396 104.425 126.805L1.58476 126.805Z" />
      </mask>
      <path
        d="M1.58476 126.805C1.58476 113.424 3.74023 100.131 7.96888 87.4313L105.574 119.717C104.813 122.003 104.425 124.396 104.425 126.805L1.58476 126.805Z"
        fill={colors[15]?.hex}
      />
      <path
        d="M1.58476 126.805C1.58476 113.424 3.74023 100.131 7.96888 87.4313L105.574 119.717C104.813 122.003 104.425 124.396 104.425 126.805L1.58476 126.805Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-8-outside-8_729_30204)"
      />
      <mask
        id="path-9-outside-9_729_30204"
        maskUnits="userSpaceOnUse"
        x="143.415"
        y="131.805"
        width="105"
        height="69"
        fill="black"
      >
        <rect fill="white" x="143.415" y="131.805" width="105" height="69" />
        <path d="M246.323 165.292C242.372 177.459 236.571 188.951 229.123 199.365L145.382 139.865C146.723 137.991 147.767 135.923 148.478 133.732L246.323 165.292Z" />
      </mask>
      <path
        d="M246.323 165.292C242.372 177.459 236.571 188.951 229.123 199.365L145.382 139.865C146.723 137.991 147.767 135.923 148.478 133.732L246.323 165.292Z"
        fill={colors[6]?.hex}
      />
      <path
        d="M246.323 165.292C242.372 177.459 236.571 188.951 229.123 199.365L145.382 139.865C146.723 137.991 147.767 135.923 148.478 133.732L246.323 165.292Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-9-outside-9_729_30204)"
      />
      <mask
        id="path-10-outside-10_729_30204"
        maskUnits="userSpaceOnUse"
        x="50.5848"
        y="142.805"
        width="71"
        height="105"
        fill="black"
      >
        <rect fill="white" x="50.5848" y="142.805" width="71" height="105" />
        <path d="M88.3852 245.732C75.6125 241.612 63.5863 235.475 52.7658 227.555L113.638 144.94C115.586 146.365 117.75 147.47 120.049 148.212L88.3852 245.732Z" />
      </mask>
      <path
        d="M88.3852 245.732C75.6125 241.612 63.5863 235.475 52.7658 227.555L113.638 144.94C115.586 146.365 117.75 147.47 120.049 148.212L88.3852 245.732Z"
        fill={colors[11]?.hex}
      />
      <path
        d="M88.3852 245.732C75.6125 241.612 63.5863 235.475 52.7658 227.555L113.638 144.94C115.586 146.365 117.75 147.47 120.049 148.212L88.3852 245.732Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-10-outside-10_729_30204)"
      />
      <mask
        id="path-11-outside-11_729_30204"
        maskUnits="userSpaceOnUse"
        x="5.58476"
        y="50.8047"
        width="105"
        height="71"
        fill="black"
      >
        <rect fill="white" x="5.58476" y="50.8047" width="105" height="71" />
        <path d="M7.67743 88.3177C11.8109 75.5873 17.9683 63.6009 25.9146 52.8163L108.805 113.487C107.374 115.428 106.266 117.586 105.522 119.877L7.67743 88.3177Z" />
      </mask>
      <path
        d="M7.67743 88.3177C11.8109 75.5873 17.9683 63.6009 25.9146 52.8163L108.805 113.487C107.374 115.428 106.266 117.586 105.522 119.877L7.67743 88.3177Z"
        fill={colors[16]?.hex}
      />
      <path
        d="M7.67743 88.3177C11.8109 75.5873 17.9683 63.6009 25.9146 52.8163L108.805 113.487C107.374 115.428 106.266 117.586 105.522 119.877L7.67743 88.3177Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-11-outside-11_729_30204)"
      />
      <mask
        id="path-12-outside-12_729_30204"
        maskUnits="userSpaceOnUse"
        x="132.415"
        y="142.805"
        width="72"
        height="104"
        fill="black"
      >
        <rect fill="white" x="132.415" y="142.805" width="72" height="104" />
        <path d="M202.878 226.332C192.189 234.427 180.265 240.759 167.562 245.087L134.301 148.095C136.588 147.317 138.734 146.177 140.658 144.72L202.878 226.332Z" />
      </mask>
      <path
        d="M202.878 226.332C192.189 234.427 180.265 240.759 167.562 245.087L134.301 148.095C136.588 147.317 138.734 146.177 140.658 144.72L202.878 226.332Z"
        fill={colors[8]?.hex}
      />
      <path
        d="M202.878 226.332C192.189 234.427 180.265 240.759 167.562 245.087L134.301 148.095C136.588 147.317 138.734 146.177 140.658 144.72L202.878 226.332Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-12-outside-12_729_30204)"
      />
      <mask
        id="path-13-outside-13_729_30204"
        maskUnits="userSpaceOnUse"
        x="6.58478"
        y="132.805"
        width="104"
        height="72"
        fill="black"
      >
        <rect fill="white" x="6.58478" y="132.805" width="104" height="72" />
        <path d="M27.7142 203.175C19.5121 192.583 13.0695 180.746 8.63256 168.118L105.694 134.241C106.493 136.514 107.652 138.645 109.129 140.551L27.7142 203.175Z" />
      </mask>
      <path
        d="M27.7142 203.175C19.5121 192.583 13.0695 180.746 8.63256 168.118L105.694 134.241C106.493 136.514 107.652 138.645 109.129 140.551L27.7142 203.175Z"
        fill={colors[13]?.hex}
      />
      <path
        d="M27.7142 203.175C19.5121 192.583 13.0695 180.746 8.63256 168.118L105.694 134.241C106.493 136.514 107.652 138.645 109.129 140.551L27.7142 203.175Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-13-outside-13_729_30204)"
      />
      <mask
        id="path-14-outside-14_729_30204"
        maskUnits="userSpaceOnUse"
        x="51.5848"
        y="5.8047"
        width="70"
        height="105"
        fill="black"
      >
        <rect fill="white" x="51.5848" y="5.8047" width="70" height="105" />
        <path d="M53.6469 25.4149C64.536 17.589 76.6152 11.5563 89.4233 7.54731L120.236 105.338C117.931 106.06 115.756 107.146 113.796 108.555L53.6469 25.4149Z" />
      </mask>
      <path
        d="M53.6469 25.4149C64.536 17.589 76.6152 11.5563 89.4233 7.54731L120.236 105.338C117.931 106.06 115.756 107.146 113.796 108.555L53.6469 25.4149Z"
        fill={colors[18]?.hex}
      />
      <path
        d="M53.6469 25.4149C64.536 17.589 76.6152 11.5563 89.4233 7.54731L120.236 105.338C117.931 106.06 115.756 107.146 113.796 108.555L53.6469 25.4149Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-14-outside-14_729_30204)"
      />
      <mask
        id="path-15-outside-15_729_30204"
        maskUnits="userSpaceOnUse"
        x="125.415"
        y="146.805"
        width="44"
        height="107"
        fill="black"
      >
        <rect fill="white" x="125.415" y="146.805" width="44" height="107" />
        <path d="M167.242 245.195C154.527 249.488 141.203 251.719 127.779 251.802L127.14 149.304C129.557 149.289 131.955 148.888 134.244 148.115L167.242 245.195Z" />
      </mask>
      <path
        d="M167.242 245.195C154.527 249.488 141.203 251.719 127.779 251.802L127.14 149.304C129.557 149.289 131.955 148.888 134.244 148.115L167.242 245.195Z"
        fill={colors[9]?.hex}
      />
      <path
        d="M167.242 245.195C154.527 249.488 141.203 251.719 127.779 251.802L127.14 149.304C129.557 149.289 131.955 148.888 134.244 148.115L167.242 245.195Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-15-outside-15_729_30204)"
      />
      <mask
        id="path-16-outside-16_729_30204"
        maskUnits="userSpaceOnUse"
        x="-0.415211"
        y="125.805"
        width="108"
        height="43"
        fill="black"
      >
        <rect fill="white" x="-0.415211" y="125.805" width="108" height="43" />
        <path d="M8.20691 166.886C3.90226 154.212 1.66719 140.931 1.58703 127.551L104.426 126.939C104.44 129.348 104.842 131.738 105.617 134.019L8.20691 166.886Z" />
      </mask>
      <path
        d="M8.20691 166.886C3.90226 154.212 1.66719 140.931 1.58703 127.551L104.426 126.939C104.44 129.348 104.842 131.738 105.617 134.019L8.20691 166.886Z"
        fill={colors[14]?.hex}
      />
      <path
        d="M8.20691 166.886C3.90226 154.212 1.66719 140.931 1.58703 127.551L104.426 126.939C104.44 129.348 104.842 131.738 105.617 134.019L8.20691 166.886Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-16-outside-16_729_30204)"
      />
      <mask
        id="path-17-outside-17_729_30204"
        maskUnits="userSpaceOnUse"
        x="85.5848"
        y="-0.195298"
        width="43"
        height="107"
        fill="black"
      >
        <rect fill="white" x="85.5848" y="-0.195298" width="43" height="107" />
        <path d="M87.2479 8.24999C99.9806 4.00889 113.314 1.83286 126.739 1.80498L126.953 104.305C124.536 104.31 122.136 104.701 119.845 105.465L87.2479 8.24999Z" />
      </mask>
      <path
        d="M87.2479 8.24999C99.9806 4.00889 113.314 1.83286 126.739 1.80498L126.953 104.305C124.536 104.31 122.136 104.701 119.845 105.465L87.2479 8.24999Z"
        fill={colors[19]?.hex}
      />
      <path
        d="M87.2479 8.24999C99.9806 4.00889 113.314 1.83286 126.739 1.80498L126.953 104.305C124.536 104.31 122.136 104.701 119.845 105.465L87.2479 8.24999Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-17-outside-17_729_30204)"
      />
      <mask
        id="path-18-outside-18_729_30204"
        maskUnits="userSpaceOnUse"
        x="138.415"
        y="137.805"
        width="92"
        height="90"
        fill="black"
      >
        <rect fill="white" x="138.415" y="137.805" width="92" height="90" />
        <path d="M228.788 199.83C221.664 209.695 213.134 218.471 203.467 225.882L140.764 144.639C142.504 143.305 144.039 141.725 145.322 139.949L228.788 199.83Z" />
      </mask>
      <path
        d="M228.788 199.83C221.664 209.695 213.134 218.471 203.467 225.882L140.764 144.639C142.504 143.305 144.039 141.725 145.322 139.949L228.788 199.83Z"
        fill={colors[7]?.hex}
      />
      <path
        d="M228.788 199.83C221.664 209.695 213.134 218.471 203.467 225.882L140.764 144.639C142.504 143.305 144.039 141.725 145.322 139.949L228.788 199.83Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-18-outside-18_729_30204)"
      />
      <mask
        id="path-19-outside-19_729_30204"
        maskUnits="userSpaceOnUse"
        x="23.5848"
        y="137.805"
        width="92"
        height="92"
        fill="black"
      >
        <rect fill="white" x="23.5848" y="137.805" width="92" height="92" />
        <path d="M53.732 228.256C42.8363 220.439 33.2705 210.929 25.3998 200.089L108.712 139.996C110.129 141.947 111.851 143.659 113.812 145.066L53.732 228.256Z" />
      </mask>
      <path
        d="M53.732 228.256C42.8363 220.439 33.2705 210.929 25.3998 200.089L108.712 139.996C110.129 141.947 111.851 143.659 113.812 145.066L53.732 228.256Z"
        fill={colors[12]?.hex}
      />
      <path
        d="M53.732 228.256C42.8363 220.439 33.2705 210.929 25.3998 200.089L108.712 139.996C110.129 141.947 111.851 143.659 113.812 145.066L53.732 228.256Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-19-outside-19_729_30204)"
      />
      <mask
        id="path-20-outside-20_729_30204"
        maskUnits="userSpaceOnUse"
        x="23.5848"
        y="23.8047"
        width="92"
        height="92"
        fill="black"
      >
        <rect fill="white" x="23.5848" y="23.8047" width="92" height="92" />
        <path d="M25.2121 53.7793C33.0549 42.9196 42.5963 33.3855 53.4719 25.5409L113.765 108.577C111.807 109.989 110.09 111.705 108.678 113.66L25.2121 53.7793Z" />
      </mask>
      <path
        d="M25.2121 53.7793C33.0549 42.9196 42.5963 33.3855 53.4719 25.5409L113.765 108.577C111.807 109.989 110.09 111.705 108.678 113.66L25.2121 53.7793Z"
        fill={colors[17]?.hex}
      />
      <path
        d="M25.2121 53.7793C33.0549 42.9196 42.5963 33.3855 53.4719 25.5409L113.765 108.577C111.807 109.989 110.09 111.705 108.678 113.66L25.2121 53.7793Z"
        stroke="white"
        stroke-width="2"
        mask="url(#path-20-outside-20_729_30204)"
      />
      <path
        d="M126.792 220.538C178.854 220.538 221.069 178.492 221.069 126.613C221.069 74.7347 178.854 32.6885 126.792 32.6885C74.7297 32.6885 32.5151 74.7347 32.5151 126.613C32.5151 178.492 74.7297 220.538 126.792 220.538Z"
        fill="#D9D9D9"
        stroke="white"
        stroke-width="3"
      />
    </svg>
  );
}